/* EVO Standard(TM) - Theme JavaScript */
(function() {
  'use strict';

  // === Header scroll behavior ===
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', function() {
      const scrollY = window.scrollY;
      if (scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = scrollY;
    }, { passive: true });
  }

  // === Mobile menu toggle ===
  const mobileToggle = document.querySelector('.header__hamburger, .menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      const isOpen = mobileMenu.classList.contains('open');
      if (isOpen) {
        mobileMenu.classList.remove('open');
        mobileToggle.closest('.site-header').classList.remove('menu-open');
        mobileToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      } else {
        mobileMenu.classList.add('open');
        mobileToggle.closest('.site-header').classList.add('menu-open');
        mobileToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }
    });
  }

  // === Mobile accordion ===
  document.querySelectorAll('.mobile-nav-item.has-children > .mobile-nav-link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const subnav = this.nextElementSibling;
      if (subnav) {
        subnav.style.display = subnav.style.display === 'flex' ? 'none' : 'flex';
        this.querySelector('.mobile-nav-toggle').textContent = subnav.style.display === 'flex' ? '' : '+';
      }
    });
  });

  // === Reveal on scroll ===
  function initReveal() {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const children = entry.target.querySelectorAll('.reveal-up, .reveal-fade');
          children.forEach(function(child, i) {
            setTimeout(function() { child.classList.add('revealed'); }, i * 120);
          });
          if (entry.target.classList.contains('reveal-up') || entry.target.classList.contains('reveal-fade')) {
            entry.target.classList.add('revealed');
          }
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('[data-reveal]').forEach(function(el) {
      observer.observe(el);
    });
  }

  // === Parallax ===
  function initParallax() {
    window.addEventListener('scroll', function() {
      document.querySelectorAll('[data-parallax]').forEach(function(el) {
        var speed = parseFloat(el.getAttribute('data-parallax') || '0.3');
        var rect = el.getBoundingClientRect();
        var viewH = window.innerHeight;
        var relPos = (rect.top + rect.height / 2 - viewH / 2) / viewH;
        var img = el.querySelector('[data-parallax-img]');
        if (img) {
          img.style.transform = 'translateY(' + (relPos * speed * 120) + 'px)';
        }
      });
    }, { passive: true });
  }

  // === Desktop dropdown - hover + click/touch ===
  document.querySelectorAll('.nav-item.has-dropdown').forEach(function(item) {
    let timeout;
    // Hover (desktop)
    item.addEventListener('mouseenter', function() {
      clearTimeout(timeout);
      item.classList.add('open');
      item.querySelector('button').setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('mouseleave', function() {
      timeout = setTimeout(function() {
        item.classList.remove('open');
        item.querySelector('button').setAttribute('aria-expanded', 'false');
      }, 150);
    });
    // Click/touch (mobile + keyboard)
    var btn = item.querySelector('button.nav-link');
    if (btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = item.classList.contains('open');
        // Close all other dropdowns first
        document.querySelectorAll('.nav-item.has-dropdown.open').forEach(function(other) {
          if (other !== item) {
            other.classList.remove('open');
            var ob = other.querySelector('button');
            if (ob) ob.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.toggle('open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    }
  });
  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.nav-item.has-dropdown')) {
      document.querySelectorAll('.nav-item.has-dropdown.open').forEach(function(item) {
        item.classList.remove('open');
        var btn = item.querySelector('button');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Init
  if (document.readyState === 'loading') {
    // Re-initialize reveal when Shopify Customizer re-renders a section
document.addEventListener('shopify:section:load', function(event) {
  initReveal();
});
document.addEventListener('shopify:section:reorder', function() {
  initReveal();
});

document.addEventListener('DOMContentLoaded', function() {
      initReveal();
      initParallax();
    });
  } else {
    initReveal();
    initParallax();
  }
})();
